import { render } from "./RsolNoticiaView.vue?vue&type=template&id=7e45ee56&scoped=true"
import script from "./RsolNoticiaView.vue?vue&type=script&lang=js"
export * from "./RsolNoticiaView.vue?vue&type=script&lang=js"

import "./RsolNoticiaView.vue?vue&type=style&index=0&id=7e45ee56&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e45ee56"]])

export default __exports__